import React, { Component } from "react";
import "./saveMarketImage.scss";
import { Toast, WhiteSpace, WingBlank, Button, Tag } from "antd-mobile";
import axios from "../axios";
import html2canvas from "html2canvas";
import { Item } from "antd-mobile/lib/tab-bar";

var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

class saveMarketImage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            userId : "",
            nickName: "",
            resultObject :{},
            priceList:[],
        };
    }

     getUrlParam = (name) => {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = this.props.location.search.substr(1).match(reg);
        if (r != null) {
          return decodeURI(r[2]);
        }
        return ""; //如果此处只写return;则返回的是undefined
    };

    saveWindowImage = ()=>{//保存图片

        this.setState({
            saveimgPrompt : "正在生成图片",
        })
        const captureElement = document.getElementById('all_content_div');
        const options = {
            scale: window.devicePixelRatio, // 高清缩放
            width: window.innerWidth,
            height: window.height,
            useCORS: true, // 解决跨域资源问题
        };
        
        html2canvas(captureElement, options).then(canvas => {
            let imgData = canvas.toDataURL('image/png' , 0.3);
            var ua = navigator.userAgent.toLowerCase();
            var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";
            let imageData = imgData.substring(imgData.indexOf(',') + 1);
            if (isApp) {
                if (isiOS) {
                    try {
                        window.webkit.messageHandlers.IOSNativeSaveImage.postMessage({"imageData" : imageData});
                    } catch (e) {
                    }
                }else{
                    try {
                        window.app.androidNativeSaveImage(imageData);
                    } catch (e) {
                    }
                }
            }
        });
    }

    componentDidMount (){

        sessionStorage.setItem("Authorization",this.getUrlParam('tokenHead')+' '+this.getUrlParam('tokenCode'));
        sessionStorage.setItem("cAppVersion",this.getUrlParam('v'));
        let userId = this.getUrlParam('userId');
        let tag = this.getUrlParam('tag');
        let oid = this.getUrlParam('oid');
        const newDate = formatDate();

        const _this = this;
        axios
            .post("data/json/getScreenshotDetails",{userId : userId, oid : oid, marketTag : tag, pageType : 'market'})
            .then(function (response){
                
                if (response.data.code === 10000) {
                    let resultObject = response.data.resultObject;
                    let priceList = resultObject.priceList;
                    _this.setState({
                        otherName : resultObject.otherName,
                        userid : userId,
                        resultObject : resultObject,
                        priceList : priceList,
                        newDate :newDate,
                    });

                    setTimeout(() => {
                        _this.saveWindowImage();
                    }, 500);
                    
                }else {
                    let message = response.data.message;
                    Toast.show(message, 2);
                }
            })

            .catch(function (error) {
                console.log(error);
            });

    }

    render() {
        return (
            <div className="saveMarketImage_div">
                <div id="all_content_div" className="all_content_div">
                    <div className="navTitle_div">
                        <p className="navtitle_p">邮宝APP</p>
                    </div>
                    <div className="content_div" >
                        <div className="title_price_div">
                            <div className="left_column_div">
                                <p className="title_p">{this.state.resultObject.title}</p>  
                                <p>￥<span className="priceNumber_span">{this.state.resultObject.price}</span><span className="unit_span">/{this.state.resultObject.unit}</span></p>    
                            </div>
                            <div className="right_button_div">
                                <button className="collection_button">+关注</button>
                            </div>
                            <p className="nickName_p">{this.state.resultObject.nickname} {this.state.newDate}</p>
                        </div>
                        <div className="seat_div"></div>

                        <div className="historyPrice_div">
                            <p className="historyPrice_p">历史价格</p>
                            <p className="historyPrice_p morePrice_p">查看更多{'>'}</p>  
                        </div>

                        <div className="price_list_div">
                            <ul className="price_ul price_grey_ul">
                                <li className="price_date_li">日期</li>
                                <li className="price_line_li"></li>
                                <li className="price_unit_li">单位</li>
                                <li className="price_line_li"></li>
                                <li className="price_price_li">价格（元）</li>
                            </ul>
                            {this.state.priceList.map((item, key) =>(
                                <ul className="price_ul" key={key}>
                                    <li className="price_date_li">{item.date}</li>
                                    <li className="price_line_li"></li>
                                    <li className="price_unit_li">{item.unit}</li>
                                    <li className="price_line_li"></li>
                                    <li className="price_price_li">{item.price}</li>
                                </ul>
                            ))}
                        </div>
                    </div>
                    <div className="AD_div">
                        <div className="lookHangQing_div">
                            <img className="hangqing_img" src = "http://image.ybk008.com/YB_marketScreenshot_Icon.png"></img>
                            <p className="hangqingtitle_p">{this.state.resultObject.title}<br/>实时行情价格邮宝查</p>
                        </div>
                        <p className="introduction_p">买卖邮币卡  行情邮宝APP查</p>
                    </div>   
                </div>
           </div>
        );   
    }
}

function formatDate() {
  const date = new Date();
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  const seconds = ('0' + date.getSeconds()).slice(-2);
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export default saveMarketImage;
